export function getCookie(name) {
  if (typeof document === "undefined") return null;
  const encodedName = encodeURIComponent(name) + "=";
  const parts = document.cookie ? document.cookie.split("; ") : [];
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    if (part.indexOf(encodedName) === 0) {
      return decodeURIComponent(part.substring(encodedName.length));
    }
  }
  return null;
}

export function setCookie(name, value, options = {}) {
  if (typeof document === "undefined") return;
  const {
    days = 180,
    path = "/",
    sameSite = "Lax",
    secure = typeof location !== "undefined" ? location.protocol === "https:" : false,
  } = options;

  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(String(value))}; Expires=${expires}; Path=${path}; SameSite=${sameSite}`;
  if (secure) cookie += "; Secure";
  document.cookie = cookie;
}

